
import { Component } from "vue-property-decorator";
import AppComposeMixin from "./mixin";

/**
 * 品牌方 app 排版页面
 * 独立组件 name，与 appCompose 的缓存互不干扰
 */
@Component({ name: 'app-compose-merchant', inject: [] })
export default class MerchantAppCompose extends AppComposeMixin {}
